import { useTranslation } from 'react-i18next';

import { useProductPartsCount } from 'hooks/orderForms/useProductPartsCount';
import { useProductPricePerUnit } from 'hooks/orderForms/useProductPricePerUnit';
import { formatCurrency } from 'support/helpers/currency/currency';
import { OrderFormProductDTO } from 'support/types';
import { ProductPartsInfo } from 'components/OrderForms/ProductPartsInfo/ProductPartsInfo';

export const ProductPartsSection = ({ product }: { product: OrderFormProductDTO }) => {
  const { t } = useTranslation();
  const pricePerUnit = useProductPricePerUnit(product);
  const productPartsCount = useProductPartsCount(product);

  if (pricePerUnit == null || productPartsCount == null) {
    return null;
  }

  return (
    <div data-testid="productparts-section" className="flex items-center justify-end gap-2 text-xs text-gray-500">
      <ProductPartsInfo product={product} partsCount={productPartsCount} />
      <span className="text-gray-200">|</span>
      <span>
        {t('orderForms:form.product.pricePerUnit', {
          pricePerUnit: formatCurrency(pricePerUnit, product.currency),
        })}
      </span>
    </div>
  );
};
